/**
 * @desc 查询水泥包装年计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanYearCementPackagingResponse>> {
  return defHttp.post({
    url: '/web/plan/year/queryPlanCementPackaging',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanYearCementPackagingResponse>> {
  return defHttp.post({
    url: '/mock/web/plan/year/queryPlanCementPackaging',
    data,
  });
}
